import { getMe } from "@src/domains/shared/apis/accountApi";
import { logoutRequest } from "@src/domains/shared/apis/authApi";
import { UserOverview } from "@src/domains/shared/models/Dtos/userOverview";
import {
  clearClientAuthState,
  clearLegacyAuthStorage,
} from "@src/domains/shared/services/authStorage";
import { z } from "zod";

export { clearClientAuthState, clearLegacyAuthStorage } from "@src/domains/shared/services/authStorage";

export const logout = async (): Promise<void> => {
  await logoutRequest();
  clearClientAuthState();
};

export const bootstrapAuthSession = async (): Promise<UserOverview | null> => {
  clearLegacyAuthStorage();

  try {
    return await getMe({ skipAuthRefresh: true });
  } catch {
    return null;
  }
};

export const passwordValidationSchema = z
  .string()
  .min(8, { message: "Das Passwort muss mindestens 8 Zeichen lang sein." })
  .regex(/\d/, {
    message: "Das Passwort muss mindestens eine Ziffer enthalten.",
  })
  .regex(/[^a-zA-Z0-9]/, {
    message:
      "Das Passwort muss mindestens ein nicht alphanumerisches Zeichen enthalten.",
  })
  .regex(/[A-Z]/, {
    message: "Das Passwort muss mindestens einen Großbuchstaben enthalten.",
  })
  .regex(/[a-z]/, {
    message: "Das Passwort muss mindestens einen Kleinbuchstaben enthalten.",
  })
  .refine((value) => new Set(value).size >= 2, {
    message: "Das Passwort muss mindestens 2 eindeutige Zeichen enthalten.",
  });

export const passwordUpdateSchema = z
  .object({
    password: passwordValidationSchema,
    confirmPassword: passwordValidationSchema,
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Die Passwörter stimmen nicht überein.",
    path: ["confirmPassword"],
  })
  .refine((data) => !(data.password === "" && data.confirmPassword === ""), {
    message: "Die Passwörter dürfen nicht beide leer sein.",
    path: ["confirmPassword"],
  });
